import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  field: {
    borderRadius: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: theme.palette.common.gray100,
    },
    padding: theme.spacing(1, 2),

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1, 0),
    },
  },
  hoverButtonsContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  fieldContainer: {
    width: '100%',
  },
  input: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    paddingBottom: theme.spacing(0.5),
    color: theme.palette.common.gray600,
    maxWidth: '75%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  textContent: {
    wordBreak: 'normal',
    overflowWrap: 'anywhere',
  },
  editingFieldButton: {
    maxWidth: theme.spacing(12),
  },
  clearDialogButton: {
    marginLeft: theme.spacing(1),
  },
  fieldHeader: {
    height: theme.spacing(4),
  },
}));

export default useStyles;
